import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#319E3A",
      d: "M8.077 1.22c.341-.821 1.505-.821 1.846 0l1.488 3.575a1 1 0 0 0 .843.613l3.86.31c.887.07 1.246 1.177.57 1.756l-2.94 2.52a1 1 0 0 0-.322.99l.898 3.768c.206.865-.735 1.549-1.494 1.085l-3.305-2.019a1 1 0 0 0-1.042 0l-3.305 2.019c-.76.464-1.7-.22-1.494-1.085l.899-3.767a1 1 0 0 0-.323-.992l-2.94-2.519c-.676-.579-.317-1.685.57-1.756l3.86-.31a1 1 0 0 0 .844-.613z"
    }, null, -1)
  ]))]))
}
export default { render: render }